export const IconSizeGuide = [
    { TShirtSize: 'xs', size: '16' },
    { TShirtSize: 'sm', size: '24' },
    { TShirtSize: 'md', size: '32' },
    { TShirtSize: 'lg', size: '48' },
    { TShirtSize: 'xl', size: '64' },
    { TShirtSize: '2xl', size: '96' },
];
export const sizes = {
    xs: {
        width: 16,
        height: 16,
    },
    sm: {
        width: 24,
        height: 24,
    },
    md: {
        width: 32,
        height: 32,
    },
    lg: {
        width: 48,
        height: 48,
    },
    xl: {
        width: 64,
        height: 64,
    },
    '2xl': {
        width: 96,
        height: 96,
    },
};
